import { Utility, utility_controller } from '../utility/utility_controller'

var lastScrollPos = 0

// The mobile menu / navbar is shown below the MENU breakpoint
// (`phone_menu_breakpoint`) — see scss/phone_menu_breakpoint_under. Gate the
// phone-menu scroll-hide on that, NOT on `Utility.isPhoneSize` (which is
// derived from the separate CONTENT breakpoint `layData.breakpoint`).
var isMobileMenuVisible = function () {
	return window.innerWidth <= Utility.phoneMenuBreakpoint
}

window.eventsChannel.on('scroll', function (scrollTop, scrollHeight, scrollContext) {
	if (scrollContext && scrollContext.source === 'page-overlay') {
		return
	}
	if (scrollTop > 0 && scrollTop < scrollHeight - window.innerHeight && isMobileMenuVisible()) {
		if (scrollTop > lastScrollPos && !utility_controller.isBodyFixed()) {
			if (!document.body.classList.contains('mobile-menu-open')) {
				document.body.classList.add('lay-hide-phone-menu')
			}
		} else if (document.body.classList.contains('lay-hide-phone-menu')) {
			document.body.classList.remove('lay-hide-phone-menu')
		}
		lastScrollPos = scrollTop
	}
})

window.laytheme.on('newpageshown', function () {
	if (!document.body.classList.contains('mobile-menu-open')) {
		jQuery('body').removeClass('lay-hide-phone-menu')
	}
})
